export const ColorString = 'COLOR_STRING';
export const BorderRadius = 'BORDER_RADIUS';
export const Font = 'FONT';
export const FontUrl = 'FONT_URL';

export const ColorObject = {
  background: ColorString,
  text: ColorString,
  secondaryText: ColorString,
};

export const ThemeStructure = {
  fonts: {
    links: [FontUrl],
    font: Font,
  },
  widget: {
    ...ColorObject,
    borderRadius: BorderRadius,
  },
  highlight: {
    ...ColorObject,
    borderRadius: BorderRadius,
    hover: ColorObject,
    outlined: ColorObject,
    disabled: ColorObject,
  },
  interaction: {
    ...ColorObject,
    borderRadius: BorderRadius,
    hover: ColorObject,
    outlined: ColorObject,
    disabled: ColorObject,
  },
};
